import { render } from "./switcher.vue?vue&type=template&id=286bcd89&scoped=true"
import script from "./switcher.vue?vue&type=script&lang=js"
export * from "./switcher.vue?vue&type=script&lang=js"

import "./switcher.vue?vue&type=style&index=0&id=286bcd89&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286bcd89"]])

export default __exports__